import * as yup from "yup";

export const createTripSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    title: v.string(),
    titleEn: v.string(),
    maxPersons: v.number({ min: 1 }),
    isInternational: yup.boolean().default(false),
    cityId: yup.string().when("isInternational", {
      is: true,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => v.string(),
    }),
    categoryId: v.string(),
    tripDestinations: yup.array().when("isInternational", {
      is: true,
      then: (schema) =>
        schema
          .of(
            yup.object().shape({
              countryId: v.string(),
              cityId: v.string(),
              order: yup.number(),
              days: yup
                .number()
                .transform((value, originalValue) =>
                  originalValue === "" ? undefined : value,
                )
                .typeError(t("thisFieldIsRequired"))
                .required(t("thisFieldIsRequired"))
                .integer(t("thisFieldIsRequired"))
                .min(1, t("thisFieldIsRequired")),
            }),
          )
          .min(1, t("thisFieldIsRequired")),
      otherwise: (schema) => schema.notRequired(),
    }),
    latitude: v.number(),
    longitude: v.number(),
    availableFrom: v.string(),
    availableTo: v.string(),
    description: v.string(),
    descriptionEn: v.string(),
    order: v.number(),
    isFeatured: yup.boolean().default(false),

    // photos
    tripPhotos: yup.array().when([], {
      is: () => !isEditMode, // CREATE mode
      then: (schema) => schema.min(1, t("thisFieldIsRequired")),
      otherwise: (schema) => schema.notRequired(),
    }),

    // addons
    addons: yup.array().of(
      yup.object().shape({
        addOnCategoryId: v.string(),
        name: v.string(),
        nameEn: v.string(),
        price: v.number(),
        stock: v.number(),
      }),
    ),

    // packages
    packages: yup.array().of(
      yup.object().shape({
        nameAr: v.string(),

        nameEn: v.string(),

        offer: yup
          .number()
          .transform((value, originalValue) =>
            originalValue === "" ? undefined : value,
          )
          .min(0, t("offerMustBeBetween0And100"))
          .max(100, t("offerMustBeBetween0And100"))
          .notRequired(),

        isActive: yup.boolean().default(true),
        cost: v.number(),

        unit: v.string(),

        unitNumber: v.number(),

        description: v.string(),

        descriptionEn: v.string(),

        isFeatured: yup.boolean().default(false),

        // 👇 ADD THIS
        isSpecial: yup.boolean().default(false),

        // 👇 CONDITIONAL FIELDS
        startDate: yup.string().when("isSpecial", {
          is: true,
          then: (schema) => schema.required(t("thisFieldIsRequired")),
          otherwise: (schema) => schema.notRequired(),
        }),

        endDate: yup.string().when("isSpecial", {
          is: true,
          then: (schema) =>
            schema
              .required(t("thisFieldIsRequired"))
              .test(
                "is-after-start",
                t("endDateMustBeAfterStartDate"),
                function (value) {
                  const { startDate } = this.parent;
                  if (!startDate || !value) return true;
                  return new Date(value) >= new Date(startDate);
                },
              ),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
    ),
  coupons: yup.array().when("couponEnabled", {
  is: true,
  then: (schema) =>
    schema
      .of(
        yup.object().shape({
          title: v.string(),

          titleEn: v.string(),

          body: yup.string().notRequired(),

          bodyEn: yup.string().notRequired(),

          code: yup
            .string()
            .required(t("thisFieldIsRequired")),

          discountType: yup
            .number()
            .typeError(t("thisFieldIsRequired"))
            .oneOf([0, 1], t("thisFieldIsRequired"))
            .required(t("thisFieldIsRequired")),

          discountValue: yup
            .number()
            .transform((value, originalValue) =>
              originalValue === "" ? undefined : value
            )
            .typeError(t("thisFieldIsRequired"))
            .required(t("thisFieldIsRequired"))
            .test(
              "valid-discount-value",
              t("thisFieldIsRequired"),
              function (value) {
                const { discountType } = this.parent;

                if (value === undefined || value === null) {
                  return true;
                }

                if (Number(discountType) === 0) {
                  return value >= 1 && value <= 100;
                }

                if (Number(discountType) === 1) {
                  return value > 0;
                }

                return true;
              }
            ),

          startDate: yup
            .string()
            .required(t("thisFieldIsRequired")),

          expirationDate: yup
            .string()
            .required(t("thisFieldIsRequired"))
            .test(
              "is-after-start",
              t("expirationDateMustBeAfterStartDate"),
              function (value) {
                const { startDate } = this.parent;

                if (!startDate || !value) return true;

                return new Date(value) >= new Date(startDate);
              }
            ),

          maxUseCount: yup
            .number()
            .transform((value, originalValue) =>
              originalValue === "" ? undefined : value
            )
            .typeError(t("maxUseCountMustBeGreaterThan0"))
            .test(
              "max-use-count",
              t("maxUseCountMustBeGreaterThan0"),
              (value) => value === undefined || value > 0
            )
            .notRequired(),
        })
      )
      .min(1, t("thisFieldIsRequired")),
  otherwise: (schema) => schema.notRequired(),
}),
  });
};
